import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List } from 'immutable';
import OrderOverviewReport from './OrderOverviewReport';
import { PROVIDER_ADMIN, PROVIDER_SALES_OPS, SUPER_ADMIN } from '../../config/app_config';
import { storeWithExpiration } from '../../utils/common';
import { getAccountMatchReport } from '../../actions/reports';

export class OrderOverviewReportContainer extends React.Component {
  static propTypes = {
    accountMatchReportData: PropTypes.instanceOf(List).isRequired,
    getAccountMatchReportAction: PropTypes.func.isRequired,
  };

  componentWillMount = () => {
    const { getAccountMatchReportAction } = this.props;
    const token = storeWithExpiration.get('token');
    getAccountMatchReportAction(token);
  };

  render() {
    return <OrderOverviewReport accountReportData={this.props.accountMatchReportData} />;
  }
}

const mapStateToProps = state => {
  const { account, dialog, user, reports } = state;
  const isProviderAdmin = user.get('userTypeId') === PROVIDER_ADMIN;
  const isSalesOp = user.get('userTypeId') === PROVIDER_SALES_OPS;
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  const accountMatchReportData = reports.get('accountMatchReport');
  return {
    account,
    dialog,
    isProviderAdmin,
    isSalesOp,
    isSuperAdmin,
    accountMatchReportData,
  };
};

export default connect(
  mapStateToProps,
  {
    getAccountMatchReportAction: getAccountMatchReport,
  }
)(OrderOverviewReportContainer);
